import { Borrow } from './actions/Borrow';
import { Repay } from './actions/Repay';
import { RepayWithATokens } from './actions/RepayWithATokens';
import { SetUserEMode } from './actions/SetUserEMode';
import { SetUserUseReserveAsCollateral } from './actions/SetUserUseReserveAsCollateral';
import { Supply } from './actions/Supply';
import { SwapBorrowRateMode } from './actions/SwapBorrowRateMode';
import { Withdraw } from './actions/Withdraw';
import { GetReserveData } from './getters/GetReserveData';
import { GetReserveNormalizedIncome } from './getters/GetReserveNormalizedIncome';
import { GetReserveNormalizedVariableDebt } from './getters/GetReserveNormalizedVariableDebt';
import { GetUserAccountData } from './getters/GetUserAccountData';
import { GetUserEMode } from './getters/GetUserEMode';
var actions = {
    Borrow: Borrow,
    Repay: Repay,
    RepayWithATokens: RepayWithATokens,
    SetUserEMode: SetUserEMode,
    SetUserUseReserveAsCollateral: SetUserUseReserveAsCollateral,
    Supply: Supply,
    SwapBorrowRateMode: SwapBorrowRateMode,
    Withdraw: Withdraw,
};
var getters = {
    GetReserveData: GetReserveData,
    GetReserveNormalizedIncome: GetReserveNormalizedIncome,
    GetReserveNormalizedVariableDebt: GetReserveNormalizedVariableDebt,
    GetUserAccountData: GetUserAccountData,
    GetUserEMode: GetUserEMode,
};
var AaveV3 = {
    actions: actions,
    getters: getters,
};
export { AaveV3 };
